import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BRAND } from '../data/products';

// Opening moment: the house name draws in over solid black, a gold hairline
// rules under it, then the curtain lifts. Once per browser session.

const KEY = 'mb-intro-seen';
const EASE = [0.76, 0, 0.24, 1];

export const IntroCurtain = () => {
  const [show, setShow] = useState(() => !window.sessionStorage.getItem(KEY));

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = 'hidden';
    const t = setTimeout(() => {
      window.sessionStorage.setItem(KEY, '1');
      setShow(false);
    }, 2300);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = '';
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 z-[300] flex items-center justify-center bg-mb"
          exit={{ y: '-100%' }}
          transition={{ duration: 1.05, ease: EASE }}
          data-testid="intro-curtain"
        >
          <div className="text-center px-6">
            <motion.div
              className="font-display uppercase text-mb text-[22px] md:text-[34px]"
              initial={{ opacity: 0, letterSpacing: '0.9em' }}
              animate={{ opacity: 1, letterSpacing: '0.36em' }}
              transition={{ duration: 1.5, ease: [0.22, 1, 0.36, 1] }}
            >
              {BRAND.name}
            </motion.div>
            <motion.div
              className="mt-8 h-[0.5px] bg-gold mx-auto origin-center"
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.2, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
              style={{ width: 220 }}
            />
            <motion.div
              className="mt-8 eyebrow-sm text-mb-muted"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.9, delay: 1.05 }}
            >
              {BRAND.tagline}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroCurtain;
